export default __webpack_public_path__ + "static/media/mobile security.be24c87b.png";